<button [type]="type()" (click)="onClick()" [disabled]="disabled()" [attr.aria-label]="ariaLabel()" [class]="buttonClass()">
  @if (!close()) {
    <ng-content></ng-content>
  }
</button>
